import {View} from 'backbone';
import DialogView from 'common-views/DialogView.js';
import template from 'common-views/dialogEx.ejs';
import constants from 'Constants.js';
import $ from 'jquery';

class DialogViewEx extends DialogView {

    initialize(opts){
        super.initialize(opts);
        this._template = template;


    }

    render() {
        super.render();
        const self = this;

        $('#dialog-check-input input[type=checkbox]').on('change', function (ev) {
            ev.preventDefault();
            const propVal  = ev.currentTarget.checked;

            self.model.set( 'checked', propVal, {silent: true});

        });
    }

}

export default DialogViewEx;